import { Link, useLocation} from "react-router-dom";
import { ArrowBackIcon } from "./Icons";
import React, { useState, useEffect, useRef } from 'react';
import Typed from 'typed.js';
import "./../App.css";
import ProjectsTable from "./researchTable";
import { useMediaQuery } from 'react-responsive';

const Research = ({page}) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 670 });

    return <div style={{height: "auto", width: "100%", position: "relative", backgroundSize: "cover", backgroundPosition: "center", zIndex: 0, display: "inline-block", justifyContent: "space-between"}}>
      <div id="page" style={{marginLeft: isSmallScreen ? "-8%" : "0px", fontSize: isSmallScreen ? "30px" : "40px"}}>
        <Link to="/">
        </Link>
        {page}
      </div>
      <div className="tree" style={{marginLeft: isSmallScreen ? "4%" : "24px"}}>
        <ul>
          <li>
            <a>
              <h1 style={{fontSize: isSmallScreen ? "14px" : "28px"}}>\interests</h1>
              <p style={{fontSize: isSmallScreen ? "12px" : "16px"}}>I have research experience in spectral graph theory, topological data analysis, and real analysis. Currently, I spend my time thinking about:
                <ul class="list">
                  <li style={{fontFamily: "mainFontPar"}}>Sobolev extension domains and domain boundaries</li>
                  <li style={{fontFamily: "mainFontPar"}}>Lipschitz and Monotone extension theorems</li>
                </ul>
              </p>
            </a>
          </li>
          <li>
            <a>
              <h1 style={{fontSize: isSmallScreen ? "14px" : "28px"}}>\papers</h1>
            </a>
            <ul>
              <ProjectsTable />
            </ul>
          </li>
        </ul>
      </div>
    </div>;
};

export default Research;